import { useReducer } from 'react';
import { getReassignment } from '../../../business/Reducers/reeassignment/getReassignment'
import { patchReassignmentRed } from '../../../business/Reducers/reeassignment/patchReassignment';
import { globalInitialState } from '../initialStateGlobal';

export const useGetReassignment = () => {
  const [state, dispatch] = useReducer(getReassignment, globalInitialState);
  return { state, dispatch }
}

export const usePatchReassignment = () => {
  const [state, dispatch] = useReducer(patchReassignmentRed, globalInitialState);
  return { state, dispatch }
}